// WhatsAppButton.jsx
import { useState, useEffect, useRef } from "react";
import { FaWhatsapp } from "react-icons/fa";

export const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  // Outside click listener
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="fixed bottom-6 left-6 z-50" ref={boxRef}>
      {/* Floating WhatsApp Button */}
      <button
        onClick={() => setOpen(!open)}
        className="relative bg-gradient-to-r from-green-500 to-emerald-600 text-white p-3 rounded-full shadow-lg transition transform hover:scale-110 hover:shadow-green-400/50"
        aria-label="Chat on WhatsApp"
      >
        {/* Glow animation ring */}
        <span className="absolute inset-0 rounded-full bg-green-400 opacity-30 blur-lg animate-ping"></span>

        {/* <svg
          className="w-7 h-7 relative z-10"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M12.004 2.003a9.94 9.94 0 0 0-9.935 9.936c0 1.755.457 3.435 1.325 4.931L2 22l5.27-1.376a9.935 9.935 0 0 0 4.734 1.207h.001a9.94 9.94 0 0 0 9.936-9.936 9.94 9.94 0 0 0-9.937-9.936Z" />
        </svg> */}

        <FaWhatsapp size={30}/>
      </button>

      {/* WhatsApp Chat Box */}
      {open && (
        <div className="absolute bottom-20 left-0 w-72 rounded-2xl bg-white/90 backdrop-blur-md shadow-2xl border border-green-200 overflow-hidden animate-slideUp">
          {/* Header */}
          <div className="bg-gradient-to-r from-green-500 to-emerald-600 p-4">
            <h3 className="text-white font-semibold text-lg">Chat with us</h3>
            <p className="text-green-100 text-sm">We reply within minutes</p>
          </div>

          {/* Body */}
          <div className="p-4 space-y-3">
            <a
              href="https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-3 rounded-xl bg-green-50 hover:bg-green-100 transition"
            >
              <div className="bg-green-500 text-white p-2 rounded-full shadow-md">
                <FaWhatsapp size={20} />
              </div>
              <span className="font-medium text-gray-800">
                +92 311 2891862
              </span>
            </a>
          </div>
        </div>
      )}

      {/* Animations */}
      <style jsx>{`
        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};
